// extracted by mini-css-extract-plugin
module.exports = {"container":"chips_container__39Qgz","text":"chips_text__QBgz7"};